import corpAdmin from './corpAdmin';

export default {
	corpAdminPage: corpAdmin
}